import React from 'react'
import styled from 'styled-components'

import { ReactComponent as ChevronLeftSvg } from '../../../../assets/svgs/chevron-left.svg'

type ChevronRightProps = {
  className?: string
  size?: string | number
}

const RotatedChevron = styled(ChevronLeftSvg)`
  transform: rotate(180deg);
`

export const ChevronRight = ({
  className = '',
  size = 24,
}: ChevronRightProps) => (
  <RotatedChevron width={size} height={size} className={className} />
)
